import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import { GetGeoData } from '@store/user/user.actions';
import { GeoData } from '@store/user/user.model';
import { selectGeoData } from '@store/user/user.selector';
import { filter, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PropertyIntelligenceResolver  {
  constructor(
    private readonly store$: Store<AppState>,
  ) { }

  public resolve(): Observable<boolean> {
    this.store$.dispatch(new GetGeoData());
    return this.store$.pipe(
      select(selectGeoData),
      filter((geoData: GeoData) => !!geoData),
      map((geoData: GeoData) => !!geoData),
    )
  }
}
